import shotOneMac from '@client/assets/images/shot/shot-1-mac.png';
import shotTwoMac from '@client/assets/images/shot/shot-2-mac.png';
import shotThreeMac from '@client/assets/images/shot/shot-3-mac.png';
import shotOneWin from '@client/assets/images/shot/shot-1-win.png';
import shotTwoWin from '@client/assets/images/shot/shot-2-win.png';
import shotThreeWin from '@client/assets/images/shot/shot-3-win.png';
import { GuideRPO } from '@common/modules/guide/guide.rpo';

export class DataConfig {
  static readonly GITHUB_REPO = 'https://github.com/algoux/algo-bootstrap';

  static readonly GITHUB_RELEASES_API = 'https://api.github.com/repos/Algobootstrap/algobootstrap/releases';

  static readonly GITHUB_RELEASES = 'https://github.com/algoux/algo-bootstrap/releases';

  static readonly DOCS_LINK = 'https://docs.of.ab.algoux.cn/?utm_source=ab-website';

  static readonly FAQ_LINK = 'https://docs.of.ab.algoux.cn/faq.html?utm_source=ab-website';

  static readonly SDUTACM_LINK = 'https://acm.sdut.edu.cn/?utm_source=ab-website';

  static readonly OJ_LINK = 'https://oj.sdutacm.cn/onlinejudge3/?utm_source=ab-website';

  static readonly BILIBILI_LINK = 'https://space.bilibili.com/1479542015';

  static readonly OLD_WEBSITE_LINK = 'https://ab.algoux.org/old/?utm_source=ab-website';

  static readonly VSCODE_LINK = 'https://code.visualstudio.com/';

  static readonly ALGOUX_LINK = 'https://algoux.org/?utm_source=ab-website';

  static readonly PASTE_THEN_AC_LINK = 'https://paste.then.ac/?utm_source=ab-website';

  static readonly RANKLAND_LINK = 'https://rl.algoux.cn/?utm_source=ab-website';

  static readonly INSTALL_VEDIO_LINK = 'https://www.bilibili.com/video/BV1pksnzrEbr/';

  static readonly USAGE_VEDIO_LINK = 'https://www.bilibili.com/video/BV16PsnzqEki/';
}

export class GuideConfig {
  platfrom!: string;
  constructor(p: string) {
    this.platfrom = p;
  }

  macGuideConfig: GuideRPO[] = [
    {
      id: 1,
      title: '轻松上手，配置难题全搞定',
      description: 'Algo Bootstrap 替你将复杂的配置自动完成。只需轻点鼠标，即可拥有整套编程环境。',
      guideURL: '#',
      imageURL: shotOneMac,
    },
    {
      id: 2,
      title: '开箱即用的调试支持',
      description: '无需参考教程，即使是单步调试，照样信手拈来。',
      guideURL: '#',
      imageURL: shotTwoMac,
    },
    {
      id: 3,
      title: '为初学者量身打造的辅助提示',
      description: '内置强大的代码风格和错误检查功能，助你编程一臂之力。',
      guideURL: '#',
      imageURL: shotThreeMac,
    },
  ];

  winGuideConfig: GuideRPO[] = [
    {
      id: 1,
      title: '轻松上手，配置难题全搞定',
      description: 'Algo Bootstrap 替你将复杂的配置自动完成。只需轻点鼠标，即可拥有整套编程环境。',
      guideURL: '#',
      imageURL: shotOneWin,
    },
    {
      id: 2,
      title: '开箱即用的调试支持',
      description: '无需参考教程，即使是单步调试，照样信手拈来。',
      guideURL: '#',
      imageURL: shotTwoWin,
    },
    {
      id: 3,
      title: '为初学者量身打造的辅助提示',
      description: '内置强大的代码风格和错误检查功能，助你编程一臂之力。',
      guideURL: '#',
      imageURL: shotThreeWin,
    },
  ];

  get guideConfigGroups(): GuideRPO[] {
    console.log(this.platfrom);
    if (this.platfrom === 'windows') return this.winGuideConfig;
    else return this.macGuideConfig;
  }
}

export class ReleasesConfig {
  version!: string;
  constructor(version: string) {
    this.version = version;
  }

  public downloadSingleSystemLinks(platform: string): Array<string> {
    if (platform === 'windows') {
      return [
        `https://cdn.algoux.cn/algo-bootstrap/release/${this.version}/AlgoBootstrap-windows-x64-${this.version}.exe`,
        `https://cdn.algoux.cn/algo-bootstrap/release/${this.version}/AlgoBootstrap-windows-arm64-${this.version}.exe`,
      ];
    } else {
      return [
        `https://cdn.algoux.cn/algo-bootstrap/release/${this.version}/AlgoBootstrap-mac-arm64-${this.version}.dmg`,
        `https://cdn.algoux.cn/algo-bootstrap/release/${this.version}/AlgoBootstrap-mac-x64-${this.version}.dmg`,
      ];
    }
  }

  public downloadSingleSystemLink(platform: string, arch: string): string {
    if (platform === 'windows' && arch === 'x64') {
      return `https://cdn.algoux.cn/algo-bootstrap/release/${this.version}/AlgoBootstrap-windows-x64-${this.version}.exe`;
    } else if (platform === 'windows' && arch === 'arm64') {
      return `https://cdn.algoux.cn/algo-bootstrap/release/${this.version}/AlgoBootstrap-windows-arm64-${this.version}.exe`;
    } else if (platform === 'mac' && arch === 'x64') {
      return `https://cdn.algoux.cn/algo-bootstrap/release/${this.version}/AlgoBootstrap-mac-x64-${this.version}.dmg`;
    } else if (platform === 'mac' && arch === 'arm64') {
      return `https://cdn.algoux.cn/algo-bootstrap/release/${this.version}/AlgoBootstrap-mac-arm64-${this.version}.dmg`;
    } else {
      throw new Error('Unsupported platform or architecture');
    }
  }

  public downloadAllSystemLink(): Array<string> {
    return [
      `https://cdn.algoux.cn/algo-bootstrap/release/${this.version}/AlgoBootstrap-windows-x64-${this.version}.exe`,
      `https://cdn.algoux.cn/algo-bootstrap/release/${this.version}/AlgoBootstrap-windows-arm64-${this.version}.exe`,
      `https://cdn.algoux.cn/algo-bootstrap/release/${this.version}/AlgoBootstrap-mac-arm64-${this.version}.dmg`,
      `https://cdn.algoux.cn/algo-bootstrap/release/${this.version}/AlgoBootstrap-mac-x64-${this.version}.dmg`,
    ];
  }

  public generateFileName(platform: string, arch: string, version: string): string {
    return `AlgoBootstrap-${platform}-${arch}-${version}.${platform === 'windows' ? 'exe' : 'dmg'}`;
  }
}
